export default __webpack_public_path__ + "static/media/smallme.7ffdf0c9.webp";